module.exports = __webpack_public_path__ + "img/full-01.1e785c19.png";